export default "__VITE_ASSET__BevQUQag__"